"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewFromMarkdown = void 0;
var tslib_1 = require("tslib");
var remark_parse_1 = tslib_1.__importDefault(require("remark-parse"));
var unherit_1 = tslib_1.__importDefault(require("unherit"));
var unified_1 = tslib_1.__importDefault(require("unified"));
var rehype_raw_1 = tslib_1.__importDefault(require("rehype-raw"));
var rehype_remark_1 = tslib_1.__importDefault(require("rehype-remark"));
var rehype_sanitize_1 = tslib_1.__importDefault(require("rehype-sanitize"));
var strip_markdown_1 = tslib_1.__importDefault(require("strip-markdown"));
var remark_rehype_1 = tslib_1.__importDefault(require("remark-rehype"));
var remark_stringify_1 = tslib_1.__importDefault(require("remark-stringify"));
var remark_inline_links_1 = tslib_1.__importDefault(require("remark-inline-links"));
var parser_1 = require("./parser");
var table_cell_align_1 = tslib_1.__importDefault(require("./transform/table-cell-align"));
var githubSanitizerSchema = require('hast-util-sanitize/lib/github');
var sanitizerSchema = tslib_1.__assign(tslib_1.__assign({}, githubSanitizerSchema), { ancestors: tslib_1.__assign(tslib_1.__assign({}, githubSanitizerSchema.ancestors), { img: ['p'] }) });
function viewParser(options) {
    var Local = unherit_1.default(parser_1.ViewParser);
    Local.prototype.options = Object.assign(Local.prototype.options, options);
    this.Parser = Local;
}
function lineBreak() {
    var Compiler = this.Compiler;
    var visitors = Compiler.prototype.visitors;
    visitors.break = lineBreak;
    function lineBreak() {
        return '<br />';
    }
}
function viewFromMarkdown(source, options) {
    var _a = options || {}, _b = _a.sanitize, sanitize = _b === void 0 ? true : _b, _c = _a.strip, strip = _c === void 0 ? false : _c;
    var node = unified_1.default()
        .use(remark_parse_1.default)
        .parse(source);
    if (sanitize) {
        node = unified_1.default()
            .use(remark_rehype_1.default, { allowDangerousHtml: true })
            .use(rehype_raw_1.default)
            .use(rehype_sanitize_1.default, sanitizerSchema)
            .use(rehype_remark_1.default, { newlines: true })
            .runSync(node);
    }
    if (strip) {
        node = unified_1.default()
            .use(strip_markdown_1.default)
            .runSync(node);
    }
    var safeSource = unified_1.default()
        .use(remark_stringify_1.default)
        .use(lineBreak)
        .stringify(node);
    node = unified_1.default()
        .use(viewParser, options)
        .parse(safeSource);
    node = unified_1.default()
        .use(remark_inline_links_1.default)
        .use(table_cell_align_1.default)
        .runSync(node);
    return node;
}
exports.viewFromMarkdown = viewFromMarkdown;
//# sourceMappingURL=parse.js.map